export default (items, itemState) => [
  ...items.map(item => ({
    ...item,
    additionalImageUrls: item.images?.slice(1).map(({ url }) => url) || [],
    ...(item.earlyAccess
      ? { customerAccess: item.earlyAccess.customerAccess }
      : {}),
    itemState
  }))
];
